// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/time/timeParser.js#1 $
'use strict';

angular.module('tc.timeParser', []).factory('timeParser', function(GlobalService) {
	// Default time parsing configuration
	var configuration = {
		format: 'HM',
		separator: ':',
		nowSymbol: 'N',
		amSymbol: 'AM',
		pmSymbol: 'PM',
	};

	// Get time parsing configuration from Global Service
	if (angular.isDefined(GlobalService.configuration.time)) {
		configuration = GlobalService.configuration.time;
	}

	function prepareTimeValue(timeValue) {
		timeValue = timeValue.toUpperCase();
		timeValue = timeValue.replace(/^(\s)+/, ''); // Strip out spaces before
		timeValue = timeValue.replace(/(\s)+$/, ''); // Strip out spaces after
		timeValue = timeValue.replace(/(\s){2,}/g, ' '); // Swap double for single spaces
		// Find the AM/PM index
		var periodIndex = timeValue.indexOf(' ' + configuration.amSymbol);
		if (periodIndex == -1) {
			periodIndex = timeValue.indexOf(' ' + configuration.pmSymbol);
		}
		// If time contains AM/PM, strip out everything in between the time and the period
		if (periodIndex != -1) {
			timeValue = timeValue.substring(0, periodIndex) + timeValue.substr(periodIndex + 1);
		}

		// Replace non-alphanumeric with separator
		timeValue = timeValue.replace(/[^0-9A-Za-z+-]/g, configuration.separator);
		return timeValue;
	}

	// Pad hours and minutes with '0' (discards seconds)
	function getPaddedHoursMinutesSeconds(hours, minutes) {
		if (hours < 10) hours = '0' + hours;
		if (minutes < 10) minutes = '0' + minutes;
		var formattedTime = hours + configuration.separator + minutes;
		return formattedTime;
	}

	// Accepts "N", "N-X", "N+X", adds supplied number of minutes to current time
	function getDiffTimestamp(timeValue) {
		timeValue = timeValue.replace(/(\s)+/g, ''); // Strip remaining whitespace
		var now = new Date();
		var currentTimeMs = now.getTime();

		// Get our 'diff'
		var diff = timeValue.slice(2);
		if (diff == '') diff = 0;
		if (isNaN(diff)) return 0;
		var diffMs = diff * 60 * 1000;

		// Compute the new time
		if (timeValue.charAt(1) == '+') now.setTime(currentTimeMs + diffMs);
		else if (timeValue.charAt(1) == '-') now.setTime(currentTimeMs - diffMs);
		else if (timeValue.length > 1) return '';

		return getPaddedHoursMinutesSeconds(now.getHours(), now.getMinutes());
	}

	// Converts a timestr with no delimiter to one that has
	// eg. 0359 = 03:59
	// Note: timestr needs to be 4 characters
	function getFourDigitTimestamp(timeValue) {
		if (isNaN(timeValue)) return timeValue;
		var hours = timeValue.slice(0, 2);
		var minutes = timeValue.slice(2);
		var formattedTime = hours + configuration.separator + minutes;
		return formattedTime;
	}

	// Validates a time string following a format:
	// Empty string is valid
	// Also if valid and non empty, converts time string
	// The valid format should be h{:mm}{:ss}{F}
	//     where F is the form such as am,pm (case insensitive) or blank
	// Valid strings are: 1 (=1am), 1:00pm, 13:00, 13:00pM, 1pm, 13:00:00  (zeros can precede the hour)
	// Invalid are such: 13:00am, 13:1, 13:01:2, 13:00p,
	function parseValueToTimestamp(timeValue) {
		timeValue = prepareTimeValue(timeValue);
		if (timeValue == '') return '';

		// Handle times like "n", "n+1" etc
		if (timeValue.charAt(0).toUpperCase() == configuration.nowSymbol) return getDiffTimestamp(timeValue);

		// Handle times like "1130", "2350" etc
		if ((timeValue.indexOf(configuration.separator) == -1) && (timeValue.length == 4) && !(isNaN(timeValue))) {
			timeValue = getFourDigitTimestamp(timeValue);
		}

		// Find the period (AM/PM) and its position
		var chosenPeriod = null;
		var periodIndex = null;
		var amPeriodIndex = timeValue.indexOf(configuration.amSymbol);
		var pmPeriodIndex = timeValue.indexOf(configuration.pmSymbol);
		if ((amPeriodIndex != -1) || (pmPeriodIndex != -1)) {
			if (amPeriodIndex != -1) {
				chosenPeriod = configuration.amSymbol;
				periodIndex = amPeriodIndex;
			} else if (pmPeriodIndex != -1) {
				chosenPeriod = configuration.pmSymbol;
				periodIndex = pmPeriodIndex;
			}
			if (timeValue.slice(periodIndex) != chosenPeriod)
				return ''; // Quit if time doesn't end in AM/PM
			// Trim AM/PM off end of time
			timeValue = timeValue.slice(0, periodIndex);
			if (timeValue == '') return '';
		}

		var timeComponents = timeValue.split(configuration.separator);
		if (timeComponents.length > 3) return '';
		for (var i = 0; i < timeComponents.length; i++) {
			if (timeComponents[i] == '') return '';
		}

		var hours = timeComponents[0];
		var minutes = timeComponents[1];
		var seconds = timeComponents[2];

		if (timeComponents.length == 1) {
			minutes = 0;
			seconds = 0;
		} else if (timeComponents.length == 2) {
			if (minutes.length != 2) return '';
			seconds = 0;
		} else if (timeComponents.length == 3) {
			if (minutes.length != 2) return '';
			if (seconds.length != 2) return '';
		}
		// Ensure hours are reasonable
		if ((hours > 12) && (chosenPeriod == configuration.amSymbol)) return '';
		if ((hours == 12) && (chosenPeriod == configuration.amSymbol)) hours = 0;

		if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) return '';
		hours = parseInt(hours, 10);
		minutes = parseInt(minutes, 10);
		seconds = parseInt(seconds, 10);
		if ((hours > 23) || (hours < 0) || (minutes > 59) || (minutes < 0) || (seconds > 59) || (seconds < 0)) return '';
		if ((hours < 12) && (chosenPeriod == configuration.pmSymbol)) hours += 12;

		timeValue = getPaddedHoursMinutesSeconds(hours, minutes);
		return timeValue;
	}
	
	function prettyTime(jsTime) {
		return getPaddedHoursMinutesSeconds(jsTime.getHours(), jsTime.getMinutes());
	}

	return {
		parse: parseValueToTimestamp,
		prettyTime: prettyTime
	};
});
